import { ProductItem } from '@/lib/types/api';
import useTranslation from 'next-translate/useTranslation';
import { AiOutlineFilePdf } from 'react-icons/ai';
import { last } from 'lodash-es';

export function ProductDocuments({ product }: { product: ProductItem }) {
  const { t } = useTranslation('products');
  return product.documents.length > 0 ? (
    <div className='mx-4 mb-16'>
      <h2 className='mb-4'>{t('products:DETAIL_FILES_HEADER')}</h2>
      <div className='flex flex-wrap'>
        <ul>
          {product.documents.map((document) => (
            <li key={document.id}>
              <a
                href={document.document_url}
                target='_blank'
                rel='noreferrer'
                className='flex min-h-[5rem] min-w-[20rem] max-w-[30rem] flex-col items-center justify-center space-x-2 break-words rounded-md border border-gray-300 p-4 px-8 hover:bg-gray-100 md:flex-row'
              >
                <AiOutlineFilePdf className='h-8 w-8 text-red-500' />
                <span className='max-w-[22rem] break-words text-center md:text-left'>
                  {decodeURI(last(document.document_url.split('/')) ?? '')}
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;
}
